import styled, { css } from 'styled-components';
import { color } from 'theme';
import { GREY_400 } from '../../../../../../../constants';

export const CellWrapper = styled.div`
    text-align: left;
    padding: 0 1rem;
    white-space: normal;
`;

export const RoleCell = styled(CellWrapper)`
    display: flex;
    align-items: center;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.5rem;
    padding: 1rem;
    text-transform: uppercase;
    cursor: default;
`;

export const ContentCell = styled(CellWrapper)<{ hasError?: boolean }>`
    padding: 1rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1rem;
    color: ${GREY_400};
    
    ${(props) => props.hasError && css`
        color: ${color('error.main')}
    `};
`;

export const NewContentCell = styled(ContentCell)<{ color?: string }>`
    ${(props) => !props.hasError && props.color && css`
        color: ${props.color};
    `};
`;
